import React from 'react'
import HeaderTwo from "../components/header/HeaderTwo";
import FaqOne from "../components/faq/FaqOne";
import FooterTwo from "../components/footer/FooterTwo";


function Faq() {
    return (
        <div className='home-yellow'>

            <HeaderTwo />
            <FaqOne />
            <FooterTwo />

        </div>
    )
}

export default Faq